import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.666 12c0-1.678 1.087-3.333 2.75-3.334.667 0 1.26.285 1.712.72l-.462.48-.46.482c-.245-.235-.519-.348-.79-.348-.639 0-1.416.733-1.416 2s.777 2 1.416 2c.271 0 .544-.113.787-.347a.667.667 0 0 1 .925.96l-.177.157a2.42 2.42 0 0 1-1.535.563c-1.663 0-2.75-1.655-2.75-3.333m4.462-2.614a.667.667 0 0 1-.923.962z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.334 11.333.133.014a.667.667 0 0 1 0 1.306l-.133.014h-2.667a.667.667 0 0 1 0-1.334zM2 12.667V6a2 2 0 0 1 2-2h1.334l.133.013a.667.667 0 0 1 0 1.307l-.133.014H4A.666.666 0 0 0 3.334 6v6.667a.67.67 0 0 0 .666.667h4.667l.134.013a.667.667 0 0 1 0 1.306l-.134.014H4a2 2 0 0 1-2-2m10.667-5.92V6A.667.667 0 0 0 12 5.334h-1.333a.667.667 0 0 1 0-1.334H12a2 2 0 0 1 2 2v.747a.667.667 0 1 1-1.333 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 2.666A.666.666 0 0 0 9.334 2H6.667A.67.67 0 0 0 6 2.666V6h4zM11.334 6l.133.014a.666.666 0 0 1 0 1.306l-.133.013H4.667a.667.667 0 0 1-.135-1.319L4.667 6V2.666a2 2 0 0 1 2-2h2.667a2 2 0 0 1 2 2zM4.666 9.34v-.007a.667.667 0 0 1 1.334 0v.007a.667.667 0 0 1-1.334 0M4.666 11.34v-.007a.667.667 0 0 1 1.334 0v.007a.667.667 0 0 1-1.334 0M7.333 9.334v-.007a.667.667 0 0 1 1.334 0v.007a.667.667 0 0 1-1.334 0M7.333 11.34v-.007a.667.667 0 0 1 1.334 0v.007a.667.667 0 0 1-1.334 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })